import { Backdrop } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import SnackbarAlert from "@saleor/components/SnackbarAlert";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useIntl } from "react-intl";

interface Props {
  open: boolean;
  success: boolean;
  onClose: () => void;
  mode: string;
}

const useStyles = makeStyles(
  () => ({
    backDrop: {
      zIndex: 1399
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    }
  }),
  { name: "NotRefContractSnackBar" }
);

const SubmitSnackBar = ({ open, success, onClose, mode }: Props) => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <div>
      <SnackbarAlert
        data-testid="submit-snackbar"
        severity={success ? "success" : "error"}
        open={!!open}
        onClose={onClose}
        verticalCenter={false}
        style={{ width: 400 }}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <div className={classes.snackHeadTitle}>
          {mode === "apply_all" && (
            <>
              <MyTypography
                variant="subtitle2"
                style={{ color: "#ffffff", marginRight: "2px" }}
              >
                {intl.formatMessage({
                  defaultMessage: "APPLY ALL",
                  description: "dialog header"
                })}
              </MyTypography>
              <MyTypography variant="body3" style={{ color: "#ffffff" }}>
                {success ? "ใช้กับ Item Details สำเร็จ" : ""}
              </MyTypography>
            </>
          )}
          {mode === "save_draft" && (
            <MyTypography variant="body3" style={{ color: "#ffffff" }}>
              {success ? "บันทึกฉบับร่างสำเร็จ" : "Fail to save draft"}
            </MyTypography>
          )}
        </div>
      </SnackbarAlert>
      <Backdrop open={!!open} className={classes.backDrop} />
    </div>
  );
};

export default SubmitSnackBar;
